import { render } from "./mining_sidebar.html?vue&type=template&id=f2f6192e&external"
import script from "./mining_sidebar.js?vue&type=script&lang=js&external"
export * from "./mining_sidebar.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__